import { Phone, MessageCircle, Mail } from "lucide-react";
import { COMPANY_INFO } from "@/constants/nav";

export const DirectContactButtons = () => {
  return (
    <section data-testid="contact-direct-buttons" className="bg-[#F2F9F5] border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 sm:py-16">
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href={`tel:${COMPANY_INFO.whatsappNumber}`}
            data-testid="contact-call-button"
            className="inline-flex items-center gap-2 rounded-full bg-[#0B4F37] text-white font-semibold px-6 py-3 hover:bg-[#042D1F] transition-colors"
          >
            <Phone className="h-4 w-4" />
            Call Us
          </a>
          <a
            href={COMPANY_INFO.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-button"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white font-semibold px-6 py-3 hover:bg-[#1fb355] transition-colors"
          >
            <MessageCircle className="h-4 w-4" />
            WhatsApp Us
          </a>
          <a
            href={`mailto:${COMPANY_INFO.emailPrimary}`}
            data-testid="contact-email-button"
            className="inline-flex items-center gap-2 rounded-full border border-[#0B4F37] text-[#0B4F37] font-semibold px-6 py-3 hover:bg-white transition-colors"
          >
            <Mail className="h-4 w-4" />
            Email Us
          </a>
        </div>
      </div>
    </section>
  );
};
